<template>
  <b-card
    no-body
    class="vb-card-recap"
  >
    <b-card-header class="vb-card-recap__header text text--lg text-primary semibold">
      <div class="vb-card-recap__header-item">
        <vb-icon
          :name="'occupants'"
          :size="20"
          :color="sass('primary')"
          class="mr-1"
        />
        {{ pax_label }}
      </div>
      <div class="vb-card-recap__header-item">
        <vb-icon
          :name="'calendar'"
          :size="20"
          :color="sass('primary')"
          class="mr-1"
        />
        {{ dates_label }}
      </div>
    </b-card-header>
    <b-card-body>
      <b-card-title class="vb-card-recap__title">
        <span class="vb-card-recap__title-item h5 regular">
          <vb-icon
            :name="'bed'"
            :size="17"
            :color="sass('primary')"
            class="mr-1"
          />{{ selected_room_name }}
        </span>
        <span class="vb-card-recap__title-item h5 regular">
          <vb-icon
            :name="'cutlery'"
            :size="17"
            :color="sass('primary')"
            class="mr-1"
          />{{ selected_rate_name }}
        </span>
      </b-card-title>
      <b-card-text class="vb-card-recap__price">
        <span>
          Il prezzo che vedi è già comprensivo delle riduzioni o eventuali gratuità previste per i bambini.
        </span>
        <span>
          <span class="text--lg text-right semibold">
            &euro; {{ display_price }}
            <em class="text--sm regular">
              (&euro; {{ price_per_person }}/pers.)
            </em>
          </span>
        </span>
      </b-card-text>
    </b-card-body>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { round, divide } from 'mathjs'
import moment from 'moment'

export default {
  name: 'card-recap-only-stay',

  inheritAttrs: false,

  inject: ['room_selection'],

  props: {
    hotel_data: {
      type: Object,
      default: null,
    },
  },

  computed: {
    ...mapState({
      occupancy: state => state.occupancy,
      checkin: state => state.liveat.checkin_date,
      checkout: state => state.liveat.checkout_date,
    }),

    room_occupancy() {
      return (this.occupancy && this.occupancy[0]) || {}
    },

    adults() {
      return this.room_occupancy.adults || 0
    },

    children_ages() {
      return this.room_occupancy.children || []
    },

    total_pax() {
      return this.adults + this.children_ages.length
    },

    pax_label() {
      let label = `${this.adults} ${this.adults > 1 ? 'adulti' : 'adulto'}`
      if (this.children_ages.length > 0) {
        label += ` + ${this.children_ages.length} ${this.children_ages.length > 1 ? 'bambini' : 'bambino'}`
      }
      return label
    },

    nights() {
      if (!this.checkin || !this.checkout) return 0
      return moment(this.checkout).diff(moment(this.checkin), 'days')
    },

    dates_label() {
      if (!this.checkin || !this.checkout) return ''
      const fmt = 'D MMMM YYYY'
      const from = moment(this.checkin).locale('it').format(fmt)
      const to = moment(this.checkout).locale('it').format(fmt)
      const nights_label = this.nights === 1 ? '1 notte' : `${this.nights} notti`
      return `${from} - ${to} (${nights_label})`
    },

    rooms() {
      const data = this.hotel_data && this.hotel_data.data
      if (data && data.rooms) return data.rooms
      return []
    },

    selected_room() {
      if (this.room_selection.index === null) return null
      return this.rooms[this.room_selection.index] || null
    },

    selected_rate() {
      if (!this.room_selection.rate) return null
      return this.room_selection.rate
    },

    selected_room_name() {
      if (!this.selected_room || !this.selected_room.name) return ''
      const name = this.selected_room.name
      return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
    },

    selected_rate_name() {
      if (!this.selected_rate || !this.selected_rate.description) return ''
      const desc = this.selected_rate.description
      return desc.charAt(0).toUpperCase() + desc.slice(1).toLowerCase()
    },

    display_price() {
      if (!this.selected_rate || !this.selected_rate.pricing) return '0'
      return this.markup(this.selected_rate.pricing.total).display_price
    },

    price_per_person() {
      if (!this.selected_rate || !this.selected_rate.pricing || !this.total_pax) return '0'
      return round(divide(this.markup(this.selected_rate.pricing.total).display_price, this.total_pax), 2)
    },
  },

  methods: { 
    round,
    divide,
  },
}
</script>